<template>
  <div class="profile">
    <div class="container">
      <div
        v-if="$route.query.profile"
        class="d-flex text-center align-items-center top-div"
      >
        <router-link button to="/profile">
          <b-icon icon="arrow-left-short"></b-icon>
        </router-link>
        <h5>
          <b>{{ $t(getTranslationKey($route.query.profile)) }}</b>
        </h5>
      </div>
      <div v-else pt-0>
        <h5>{{ $t("myorders") }}</h5>
      </div>
      <b-row v-if="profileData">
        <!-- <div class="pro"> -->
        <!-- <b-col md="6" class="pro">
          <template v-if="$options.components['profile-show-edit-profile']">
            <profile-show-edit-profile :editKey="false" />
          </template>
        </b-col> -->
        <!-- </div> -->
        <b-col>
          <!-- <div class="d-flex justify-content-between mb-3 mt-3"> -->
          <!-- <div>
              <h5>My Orders</h5>
            </div> -->
          <!-- <div></div>
          </div> -->
          <div class="promotional_akshay_tab_div text-center">
            <!-- <b-tabs v-model="tabIndex" pills> -->
            <!-- <b-tab
								:title-link-class="linkClass(0)"
								title="Product Order"
								active
							> -->
            <div
              v-if="orderList.length"
              class="d-flex justify-content-center mb-6 mt-6"
            >
              <b-list-group class="list-group-order">
                <template v-if="$options.components['profile-order']">
                  <profile-order
                    :orderItem="item"
                    v-for="(item, index) in orderList"
                    :key="index"
                    @writeReview="writeReview"
                    @editReview="editReview"
                  />
                </template>
              </b-list-group>
            </div>
            <div v-else>
              <b-img center src="product.PNG" class="mr-3 w-25 mt-3"></b-img>
              <h5 head-variant="light" class="text-center mt-3">
                {{ $t("myOrder.noOrders") }}
              </h5>
              <h5 head-variant="light" class="text-center color mt-3">
                {{ $t("myOrder.noOrderYet") }}
              </h5>
              <b-col md="12" class="text-center pb-3">
                <button class="btn colors btn-lg" @click="startTrips">
                  {{ $t("myOrder.startShopping") }}
                </button>
              </b-col>
            </div>
            <!-- </b-tab> -->
            <!-- <b-tab :title-link-class="linkClass(1)" title="Service Order">
                <div class="d-flex justify-content-between mb-1 mt-1">
                  <b-list-group class="list-group-order">
                    <template v-if="$options.components['profile-order']">
                      <profile-order
                        :orderItem="item"
                        v-for="(item, index) in serviceOrderList"
                        :key="index"
                      />
                    </template>
                  </b-list-group>
                </div>
                <div v-if="!serviceOrderList.length">
                  <b-img
                    center
                    src="service.PNG"
                    class="mr-3 w-25 mt-3"
                  ></b-img>
                  <h5 head-variant="light" class="text-center mt-3">
                    You Have No Service Orders!
                  </h5>
                  <h5 head-variant="light" class="text-center color mt-3">
                    Looks like you haven't booked any In Service Orders yet.
                  </h5>
                  <b-col md="12" class="text-center pb-3">
                    <button class="btn btn-lg colors" @click="startTrips">
                      Start Booking
                    </button>
                  </b-col>
                </div>
              </b-tab>

              <b-tab :title-link-class="linkClass(2)" title="In-Store">
                <div class="d-flex justify-content-between mb-1 mt-1">
                  <b-list-group class="list-group-order">
                    <template v-if="$options.components['profile-order']">
                      <profile-order
                        :orderItem="item"
                        v-for="(item, index) in InStoreOrderList"
                        :key="index"
                      />
                    </template>
                  </b-list-group>
                </div>
                <div v-if="!InStoreOrderList.length">
                  <b-img
                    center
                    src="instore.PNG"
                    class="mr-3 w-25 mt-3"
                  ></b-img>
                  <h5 head-variant="light" class="text-center mt-3">
                    You Have NO Instore Orders!
                  </h5>
                  <h5 head-variant="light" class="text-center color mt-3">
                    Looks like You haven't created any In Store Orders Yet
                  </h5>
                  <b-col class="text-center pb-3">
                    <button class="btn btn-lg colors" @click="startOrder">
                      Create Instore Order
                    </button>
                  </b-col>
                </div>
              </b-tab> -->
            <!-- </b-tabs> -->
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4" v-else>
        <b-col md="6">
          <div class="text-center login-signup-myaccout">
            <h4 class="mb-4">{{ $t("myOrder.signInToView") }}</h4>
            <button
              class="btn btn-primary mb-4"
              @click="$router.push('/login-with')"
            >
              {{ $t("accountDetails.loginSignup") }}
            </button>
          </div>
        </b-col>
      </b-row>
      <b-modal
        id="bv-write-review"
        size="lg"
        :hide-footer="true"
        :hide-header="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        centered
        header-class="my-class"
        body-class="p-0"
      >
        <!-- <h2>asdfasd</h2> -->
        <template
          v-if="
            showWriteReviewModal &&
            $options.components['profile-write-review-modal']
          "
        >
          <profile-write-review-modal
            :orderId="orderId"
            :item="selectedItem"
            :isEdit="isEditReview"
            @review-submitted="writeReviewDone"
          />
        </template>
      </b-modal>
      <b-modal
        id="bv-write-review-done"
        size="lg"
        :hide-footer="true"
        :hide-header="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        centered
        header-class="my-class"
        body-class="p-0"
      >
        <b-card>
          <b-row class="text-center">
            <b-col md="12">
              <div class="reviewDoneSec">
                <img src="img/reviewDone.svg" />
                <h3 class="mt-4">
                  {{
                    isReviewEditSuccess
                      ? "Write review updated successfully!"
                      : "Write review submitted successfully!"
                  }}
                </h3>
                <h6 class="mb-4">
                  Thanks for the feedback on your experience.
                </h6>
                <b-button
                  class="Ok-button mb-4"
                  variant="primary"
                  @click="refreshOrderListAfterDone"
                >
                  Ok
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "my-order",
  data() {
    return {
      tabIndex: 0,
      profileData:
        localStorage.getItem(`${process.env.VUE_APP_TENANT}:userInfo`) !== null,
      orderId: null,
      selectedItem: null,
      isEditReview: false,
      isReviewEditSuccess: false,
      showWriteReviewModal: false,
    };
  },
  computed: {
    ...mapState({
      orderList: (state) => state.profile.orderList,
      serviceOrderList: (state) => state.profile.serviceOrderList,
      InStoreOrderList: (state) => state.profile.InStoreOrderList,
    }),
  },
  methods: {
    ...mapActions("profile", ["fetchOrderList"]),
    getTranslationKey(label) {
      const map = {
        "My Orders": "myorders",
      };
      return map[label] || label;
    },
    // linkClass(idx) {
    // 	if (this.tabIndex === idx) {
    // 		return ["bg-primary", "text-light"];
    // 	} else {
    // 		return ["bg-light", "text-info"];
    // 	}
    // },
    startTrips() {
      this.$router.push("/");
    },
    startOrder() {
      this.$router.push("/storeOrder");
    },
    writeReview({ orderId, item }) {
      this.orderId = orderId;
      this.selectedItem = item;
      this.isEditReview = false;
      this.showWriteReviewModal = true;

      this.$nextTick(() => {
        this.$bvModal.show("bv-write-review");
      });
    },
    editReview({ orderId, item }) {
      this.orderId = orderId;
      this.selectedItem = item;
      this.isEditReview = true;
      this.showWriteReviewModal = true;

      this.$nextTick(() => {
        this.$bvModal.show("bv-write-review");
      });
    },
    writeReviewDone(isEdit) {
      this.isReviewEditSuccess = isEdit;
      this.$bvModal.hide("bv-write-review");
      this.$bvModal.show("bv-write-review-done");
      this.resetReviewModalState();
    },
    refreshOrderListAfterDone() {
      this.fetchOrderList();
      this.resetReviewModalState();
      this.$bvModal.hide("bv-write-review-done");
    },
    resetReviewModalState() {
      this.orderId = null;
      this.selectedItem = null;
      this.isEditMode = false;
      this.showWriteReviewModal = false;
    },
  },
  async mounted() {
    if (!this.profileData) {
      return;
    }
    await this.$store.dispatch("profile/fetchOrderList");
    await this.$store.dispatch("profile/fetchServiceOrderList");
    await this.$store.dispatch("profile/fetchInStoreOrderList");
    if (this.$route.query?.orderId && this.orderList.length) {
      this.writeReview(this.$route.query.orderId);
    }
  },
};
</script>

<style scoped>
.heading {
  font-weight: 700;
  color: #090909;
  margin-left: 120px;
}
.bi-arrow-left-short {
  height: 3rem;
  width: 3rem;
  color: var(--primarycolor);
  padding: 0px;
}

.bi-arrow-left-short:hover {
  color: var(--darkcolor);
}
.promotional_akshay_tab_div .nav-pills .nav-link.active {
  background: var(--primarycolor) !important ;
  padding: 9px 35px;
  color: #fff;
}
.need-helpbtn {
  color: #272727;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: var(--darkcolor);
}
.need-helpbtn:hover {
  color: #fff;
}
.color {
  color: #808080;
  font-size: 15px;
}
.noservice-image img {
  padding-top: 20px;
}
.noservice-image img {
  width: 80%;
}
.order-maindiv {
  background: #f8f8f8;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 15px;
  margin-right: 15px;
  border: 1px solid #efefef;
}
.cancelled-button {
  background: #c83500;
  color: #fff;
  padding: 2px 7px 2px 7px;
  font-size: 14px;
}
.xsbutton {
  background: #272727;
  color: #fff;
  padding: 2px 7px 2px 7px;
  font-size: 14px;
}
.xs-button {
  background: #4368e2;
  color: #fff;
  padding: 2px 7px 2px 7px;
  font-size: 14px;
}
.created {
  text-decoration: none;
  color: #fff;
  background: #07ac04;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  justify-content: center;
  margin-bottom: 0;
  list-style: none;
}
.delivered {
  text-decoration: none;
  color: #fff;
  padding: 3px;
  background: #07ac04;
}
.items-more a {
  color: var(--primarycolor);
  border: 1px solid var(--primarycolor);
  border-radius: 40px;
  padding: 2px 10px 3px 10px;
  position: relative;
  background: #f8f8f8;
}
.items-more a:hover {
  text-decoration: none;
  background: var(--primarycolor);
  color: #fff !important;
}
.items-more {
  position: relative;
}
.items-more:before {
  position: absolute;
  height: 1px;
  width: 100%;
  background: #e9e9e9;
  content: "";
  left: 0;
  right: 0;
  top: 12px;
}
.colors {
  border: 2px solid var(--primarycolor);
  color: var(--primarycolor);
  font-weight: 600;
}
.cancel-dv {
  background: #cc0000 !important;
}
.margin-create-button {
  border: 1px solid #08600c;
  color: #08600c;
  border-radius: 14px;
  font-size: 14px;
  margin-top: 20px;
}
.nav-pill {
  color: #fff;
  background-color: #368b3b;
}
.list-group-order {
  margin-top: 15px;
  max-height: 940px;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.image-instore {
  height: 80px;
  width: 80px;
}
.pro {
  margin-bottom: 60px;
  margin-block: 64px;
  /* padding:40px; */
}
.reviewDoneSec img {
  width: 350px;
}
.Ok-button {
  width: 120px;
}
</style>